import { gql } from '@apollo/client';

export const GET_WELDS = gql`
  query GetWelds($projectId: ID!, $filters: WeldFilterInput, $page: Int, $size: Int) {
    welds(project_id: $projectId, page: $page, size: $size, filters: $filters) {
      list {
        id
        no
        welding_progress
        weld_joint_type {
          weld_type {
            id
            name
          }
          joint_type {
            id
            name
          }
        }
        length
        material_1 {
          designation_name
        }
        material_2 {
          designation_name
        }
        wps {
          no
        }
        welder {
          date
          person {
            first_name
            last_name
            uuid
          }
        }
        extra_data
        status
        inspections
        inspection_groups
        inspection_category {
          name
          hold_time
          inspections {
            range
            type_id
          }
        }
      }
      metadata {
        current_page
        next_page
        prev_page
        total_count
        total_pages
      }
    }
  }
`;
